import * as React from 'react';

import { cn } from 'lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					// aria-[invalid=true]: bug real encontrado al documentar ui/Form —
					// FormControl pone aria-invalid solo cuando react-hook-form marca
					// error, pero Input no reaccionaba a eso: aria-invalid quedaba bien
					// puesto para lectores de pantalla, el borde se quedaba sin cambiar
					// para todo el mundo más. Variante arbitraria (no la forma corta
					// aria-invalid:), no depende de que esté en el preset por defecto.
					//
					// Forma y foco (decisión de diseño de Elena, antes en un CSS global de Storybook):
					// altura h-9, radio propio de control (el mismo que Button y Select, para que un
					// formulario no mezcle tres radios), fondo transparente para que tome el de la
					// Card que lo contiene, y borde gris de control que al enfocar pasa a
					// --control-border-focus en vez de sacar el anillo verde: "casi invisible en
					// reposo, aparece al enfocar" (7,16:1 claro / 7,38:1 oscuro). El borde en reposo
					// queda por debajo de 3:1 a propósito, ver Foundations/Accessibility.
					//
					// min-w-0: bug real encontrado documentando Screens/Invita y Gana —
					// un Input con flex-1 dentro de un flex (input + botón de copiar)
					// no se encogía por debajo de su ancho intrínseco (min-width:auto,
					// el valor por defecto en flexbox) y desbordaba la card en vez de
					// recortar el valor. En base, no por sitio — ver Foundations/Responsive.
					'flex h-11 w-full min-w-0 rounded-control border border-control-border bg-transparent px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:border-control-border-focus disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive md:text-sm',
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);
Input.displayName = 'Input';

export { Input };
